import React from 'react'
import {PrimaryButton} from '../../../core/components/unilink/index'
import Box from '../../../core/components/box/Box'
import noLeaves from '../../../core/img/no-leafs.svg'
import './noLessons.css'

class NoExplanations extends React.PureComponent {

  render() {
    const {withColor, topicId, openCreateEditor} = this.props
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        shape='round'
        border='lightGray'
        paddingX={12}
        paddingY={12}
        marginTop={7}
        marginBottom={4}>
        <Box
          justifyContent='center'
          alignItems='center'
          display='flex'
          direction='column'>
          <img src={noLeaves} alt='' />
          <Box
            marginTop={4}
            marginBottom={4}>
            <h3 style={{fontWeight:'600', fontSize:'1.5rem', textAlign:'center'}}> This lesson has no explanations yet...</h3>
          </Box>
          <Box
            marginBottom={8}
            maxWidth='20rem'
            width='100%'>
            <span style={{fontSize:'.875rem','fontWeight':'500', textAlign:'center', display: 'block'}}>View subjects to explore our other topics!</span>
          </Box>
          
            <PrimaryButton className={`no-lessons__button topic-header__enter-gm--${withColor}`} to='/subjects'>
              View Subjects
            </PrimaryButton>
        </Box>
      </Box>
    )
  }
}

export default NoExplanations



// WEBPACK FOOTER //
// ./src/domains/topic/components/NoExplanations.js